// Quizzes that exist on one site only and are not per trade, e.g. the Slovak
// "Povinnosti a práva remeselníka". Their copy is written here in the site's
// language instead of the locale files, so other languages need no keys; they
// appear in the dashboard, the quiz tabs and the header menu only where their
// route exists (isRouteAvailable) and are never teased elsewhere.
import { Scale, type LucideIcon } from 'lucide-react';
import { DA_RIGHTS_SITE_QUIZ } from '@/utils/daRightsQuiz/siteQuiz';
import { CS_RIGHTS_SITE_QUIZ } from '@/utils/csRightsQuiz/siteQuiz';
import { EN_RIGHTS_SITE_QUIZ } from '@/utils/enRightsQuiz/siteQuiz';
import { DE_RIGHTS_SITE_QUIZ } from '@/utils/rightsQuizDe/siteQuiz';
import { isRouteAvailable, type SiteLanguage } from '@/utils/routing';

export interface SiteQuiz {
  key: string;
  icon: LucideIcon;
  /** Route key in routing.ts; the quiz is live only where it has a path. */
  routeKey: string;
  /** Dashboard card title and full tab label. */
  title: string;
  /** Dashboard card text. */
  description: string;
  /** Tab label on phones. */
  short: string;
  /** The question in the header menu and the ticker. */
  menuLabel: string;
  /** The same four texts for the other languages where the quiz has its own version. */
  copy?: Partial<Record<SiteLanguage, SiteQuizCopy>>;
}

export type SiteQuizCopy = Pick<SiteQuiz, 'title' | 'description' | 'short' | 'menuLabel'>;

export const SITE_QUIZZES: readonly SiteQuiz[] = [
  {
    key: 'rights',
    icon: Scale,
    routeKey: 'rightsQuiz',
    title: 'Povinnosti a práva remeselníka',
    description: 'Šesť rýchlych otázok a uvidíte len to, čo sa týka vás: termíny pri daniach, odvodoch, zamestnancoch a zmluvách, aj na čo máte nárok. Pri každom bode je zdroj.',
    short: 'Povinnosti a práva',
    menuLabel: 'Aké povinnosti a práva máte ako remeselník?',
    copy: { da: DA_RIGHTS_SITE_QUIZ, cs: CS_RIGHTS_SITE_QUIZ, en: EN_RIGHTS_SITE_QUIZ, de: DE_RIGHTS_SITE_QUIZ },
  },
];

/** The one-site quizzes live on this language's site, with their copy in that language. */
export function siteQuizzesFor(lang: SiteLanguage): SiteQuiz[] {
  return SITE_QUIZZES.filter(({ routeKey }) => isRouteAvailable(routeKey, lang)).map((quiz) => ({ ...quiz, ...quiz.copy?.[lang] }));
}
